namespace TabAurous.ECommerce {
    export namespace ECommExchangeLaborService {
        export const baseUrl = 'ECommExchange/ECommExchangeLabor';

        export declare function Create(request: Serenity.SaveRequest<ECommExchangeLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommExchangeLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommExchangeLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ECommExchangeLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommExchange/ECommExchangeLabor/Create",
            Update = "ECommExchange/ECommExchangeLabor/Update",
            Delete = "ECommExchange/ECommExchangeLabor/Delete",
            Retrieve = "ECommExchange/ECommExchangeLabor/Retrieve",
            List = "ECommExchange/ECommExchangeLabor/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ECommExchangeLaborService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
